module.exports = __webpack_public_path__ + "img/bg.0d76cd12.jpg";